import { SchematicMode } from '../types';
import React, { useContext } from 'react';

export const ModeContext = React.createContext<SchematicMode | null>(null);

export const useMode = (): SchematicMode | null => {
  return useContext(ModeContext);
};
